export enum TipoAlgoritmoEnum {
  CALCULOS = 0,
  CONDICIONAIS = 1,
  REPETICOES = 2,
}
